<template>
	<div>
		<az-toolbar>
			<template #actions>
				<botao-primario
					nome-botao="Novo"
					icone="add_circle"
					v-az-auth="permissoes.fiscaisCriar"
					@click="abrirModalAdicionarFiscal"
				></botao-primario>
			</template>
			<template #simpleSearch>
				<az-search
					:filter="filtro"
					simple-search-placeholder="Buscar por nome, órgão ou situação"
					@simple-search="buscarFiscaisListagemPorFiltro"
					@remove-filter="removerFiltros"
					v-az-auth="permissoes.fiscaisListar"
					ref="componenteAzSearch"
					@clear="limparBuscaListagemPorFiltro"
				>
				</az-search>
			</template>
		</az-toolbar>
		<az-container class="listagem">
			<fiscais-listagem
				:fiscais="fiscaisDatasource"
				:total-paginas="totalPaginasListagem"
				:total-itens="totalItensListagem"
				:paginacao="paginacaoListagem"
				@paginar="setPaginacaoFiscaisListagem"
				@resetar-page="resetarPaginaFiscaisListagem"
				@recarregar-listagem-modelo-documento="carregarFiscaisListagem"
				:repositorio-flowbee="repositorioFlowbee"
			></fiscais-listagem>
		</az-container>
		<modal-adicionar-fiscal
			v-if="exibirModalAdicionarFiscal"
			:exibir="exibirModalAdicionarFiscal"
			@fechar-modal="fecharModalAdicionarFiscal"
			titulo-modal="Novo Fiscal"
			:repositorio-flowbee="repositorioFlowbee"
		>
		</modal-adicionar-fiscal>
	</div>
</template>
<script>
import { actionTypes, mutationTypes } from '@/core/constants'
import BotaoPrimario from '@/views/components/BotaoPrimario'
import Paginacao from '@/core/store/default/paginacaoListagem'
import FiscaisListagem from '@/views/pages/configuracao/fiscais/listagem/FiscaisListagem'
import ModalAdicionarFiscal from '@/views/pages/configuracao/fiscais/modal-adicionar-fiscal/ModalAdicionarFiscal'
import { mapState } from 'vuex'

export default {
	name: 'fiscais',
	components: { FiscaisListagem, ModalAdicionarFiscal, BotaoPrimario },
	data() {
		return {
			fiscaisDatasource: [],
			totalPaginasListagem: 0,
			totalItensListagem: 0,
			paginacaoListagem: Paginacao(['dataCriacao'], 25, 'DESC'),
			exibirModalAdicionarFiscal: null,
		}
	},
	computed: {
		filtro: {
			get() {
				return this.$store.state.configuracao.fiscais.filtro
			},
			set() {
				this.$store.commit(mutationTypes.CONFIGURACAO.FISCAIS.SET_FILTRO_LISTAGEM)
			},
		},
		...mapState({
			repositorioFlowbee: (state) => state.parametrosSistema.repositorioFlowbee,
		}),
	},
	async mounted() {
		await this.carregarFiscaisListagem()
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.CONFIGURACAO.FISCAIS.RESET_FILTRO_LISTAGEM)
	},
	methods: {
		async carregarFiscaisListagem() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.FISCAIS.BUSCAR_FISCAIS,
			)

			this.fiscaisDatasource = itens
			this.totalPaginasListagem = totalPages
			this.totalItensListagem = totalElements
		},
		async buscarFiscaisListagemPorFiltro(searchText) {
			if (searchText) this.filtro.nomeFiscalOuNomeOrgaoOuSiglaOrgaoOuSituacao.value = searchText.trim()

			this.resetarPaginaFiscaisListagem()
			await this.carregarFiscaisListagem()
		},
		async removerFiltros(propriedade) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
			}
			await this.carregarFiscaisListagem()
		},
		limparBuscaListagemPorFiltro() {
			this.$store.commit(mutationTypes.CONFIGURACAO.FISCAIS.RESET_FILTRO_LISTAGEM)
		},
		setPaginacaoFiscaisListagem(paginacao) {
			this.$store.commit(mutationTypes.CONFIGURACAO.FISCAIS.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarFiscaisListagem()
		},
		resetarPaginaFiscaisListagem() {
			this.$store.commit(mutationTypes.CONFIGURACAO.FISCAIS.RESET_PAGINACAO_LISTAGEM)
		},
		abrirModalAdicionarFiscal() {
			this.exibirModalAdicionarFiscal = true
		},
		async fecharModalAdicionarFiscal() {
			this.exibirModalAdicionarFiscal = false
			await this.carregarFiscaisListagem()
		},
	},
}
</script>
